var _mask, _g, _rect, _mask2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNl = function SvgNl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 2,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 3h24v17.923h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21468B",
    d: "M0 15.027h24v5.973h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3h24v5.977h-24v-5.977z",
    fill: "#AE1C28"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 2,
    fillOpacity: 0.01,
    filter: "url(#b)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    rx: 2,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nl.ae98a7de.svg";
export { ForwardRef as ReactComponent };